import { HTTP } from './helpers/http'
import qs from 'qs'

export default {
  getAll(args = {}) {
    const { organizationId, limit = 25, skip = 0, terms, sort } = args
    const params = {
      params: { skip, limit, terms, sort, filters: { source: 'web' } },
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }
    return HTTP.get(`/api/v1/organizations/${organizationId}/webhooks`, params)
  },

  create(args = {}) {
    const { organizationId, data } = args

    return HTTP.post(`/api/v1/organizations/${organizationId}/webhooks`, data)
  },

  update(args = {}) {
    const { organizationId, webhookId, data } = args

    return HTTP.put(
      `/api/v1/organizations/${organizationId}/webhooks/${webhookId}`,
      data
    )
  },

  remove(args = {}) {
    const { organizationId, webhookId } = args

    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/webhooks/${webhookId}`
    )
  },

  getLogs(args = {}) {
    const { organizationId, webhookId, limit, skip } = args

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/webhooks/${webhookId}/logs`,
      {
        params: { limit, skip },
      }
    )
  },
}
